import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storm.image.details;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_IMAGE_DETAILS',
	method: 'POST',
	url: '/storm/image/details.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
